import React from "react";
import { Wallet, Package, Percent, PiggyBank, Ticket, Crown } from "lucide-react";
import { TIER_VISUALS } from "./VipMembershipCard";

const STAT_CONFIG = [
    { key: "lifetime_spend", label: "Lifetime Spend", icon: Wallet, prefix: "A$" },
    { key: "total_orders", label: "Total Orders", icon: Package, prefix: "" },
    { key: "discount_pct", label: "Current Discount", icon: Percent, suffix: "%" },
    { key: "total_savings", label: "Total Savings", icon: PiggyBank, prefix: "A$" },
    { key: "wheel_entries", label: "Monthly Draw Entries", icon: Ticket, prefix: "" },
    { key: "vip_tier", label: "VIP Tier", icon: Crown },
];

export const VipStatsGrid = ({ stats = {}, tier = "none" }) => {
    const v = TIER_VISUALS[tier] || TIER_VISUALS.none;
    return (
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3" data-testid="vip-stats-grid">
            {STAT_CONFIG.map((s) => {
                const Icon = s.icon;
                let raw = stats[s.key];
                let value;
                if (s.key === "vip_tier") {
                    value = (TIER_VISUALS[stats.vip_tier]?.label) || "Researcher";
                } else if (s.key === "lifetime_spend" || s.key === "total_savings") {
                    value = `${s.prefix}${Number(raw || 0).toFixed(2)}`;
                } else if (s.key === "discount_pct") {
                    value = `${Number(raw || 0)}${s.suffix}`;
                } else {
                    value = `${s.prefix || ""}${Number(raw || 0)}`;
                }
                return (
                    <div
                        key={s.key}
                        className="vip-stat-card glass-elevated rounded-2xl p-4 transition-all duration-300 hover:border-[var(--gold)]/30"
                        data-testid={`vip-stat-${s.key}`}
                    >
                        <div className="flex items-center justify-between mb-2">
                            <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-[var(--text-muted)]">
                                {s.label}
                            </p>
                            <div
                                className="w-8 h-8 rounded-full flex items-center justify-center"
                                style={{
                                    background: `radial-gradient(circle, ${v.accentSoft}, transparent 70%)`,
                                    border: `1px solid ${v.border}`,
                                }}
                            >
                                <Icon size={14} style={{ color: v.accent }} />
                            </div>
                        </div>
                        <p className="font-display text-xl sm:text-2xl font-black text-white tabular-nums truncate">
                            {value}
                        </p>
                    </div>
                );
            })}
        </div>
    );
};
